import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import { history } from '../../../_helpers';
import { userActions } from '../../../_actions';
import { SubmitButton } from '../../../_components';

import { GenericNavbarComponent, GenericFooterComponent } from '../../../_components';

import './User.signup.scss';

class SignupContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      company_uuid: this.props.location.state.cp_uuid,
      company_name: this.props.location.state.cp_name,
      fullname: "",
      username: "",
      email: "",
      password: "",
      password_confirmation: "",
      submitted: false,
      confirmationSubmitted: false,
      empty: false
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    if ( sessionStorage.getItem('cellit_userdata') ) return history.push('/');

    document.title = 'Signup - Cellit.io';
  }

  handleChange(e) {
    let val = e.target.value;
    let name = e.target.name;
  
    this.setState({[name]: val});
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({submitted: true});

    const { company_uuid, fullname, username, email, password, password_confirmation } = this.state;
    if ( !company_uuid || !fullname || !username || !email || !password || !password_confirmation ) return this.setState({submitted: false, empty: true});


    const { dispatch } = this.props;
    
    let self = this;

    const obj = {
      "user": {
        "company_uuid": company_uuid,
        "name": fullname,
        "username": username,
        "email": email,
        "password": password,
        "password_confirmation": password_confirmation
      }
    }

    if ( fullname && username && email && password && password_confirmation ) {
      dispatch(userActions.signup(obj))
        .then(res => {
          if ( res.type !== 'USER_SIGNIN_FAILURE' ) {
            return self.setState({submitted: false, confirmationSubmitted: true});
          }
        
          toast.error(res.error.message, {
            position: toast.POSITION.TOP_RIGHT,
            className: 'toast-error'
          });

          this.setState({submitted: false});
        })
    }
  }

  render() {
    const { fullname, username, email, password, password_confirmation, submitted, empty } = this.state;

    return (
      <div className="register">
        <GenericNavbarComponent />

        <div className="container">
          <div className="row">
            <div className="col">
              <div className="col">
                {
                  !this.state.confirmationSubmitted ?
                    <div>
                      <h1 className="title text-center">Create your user <span role="img" aria-label="robot" aria-labelledby="robot">🤖</span></h1>
                      <p className="subtitle text-center">This is the final step (we promise)</p>
                    </div>
                  : <div>
                      <h1 className="title text-center">User has been created <span role="img" aria-label="robot" aria-labelledby="robot">🙌</span></h1>
                      <p className="subtitle text-center">A confirmation email has been submitted to your inbox.</p>
                    </div>
                }
              </div>
            </div>
          </div>

          {
            !this.state.confirmationSubmitted ?
              <div className="row">
                <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 offset-3">
                  <form id="register-form" method="POST" className="form" onSubmit={this.handleSubmit}>
                    <div className="content-group">
                      <div className='form-step'>
                        {/* Fullname */}
                        <div className="form-group">
                          <input
                            type="text"
                            name="fullname"
                            id="fullname"
                            className={empty && !fullname ? 'form-control form-control-error' : 'form-control'}
                            autoComplete="off"
                            onChange={this.handleChange}
                            defaultValue={this.state.fullname}
                          />
                          <label htmlFor="fullname">Full name</label>
                          {empty && !fullname && <div className="input-error">Provide your fullname</div>}
                        </div>

                        {/* Username */}
                        <div className="form-group">
                          <input
                            type="text"
                            name="username"
                            id="username"
                            className={empty && !username ? 'form-control form-control-error' : 'form-control'}
                            autoComplete="off"
                            onChange={this.handleChange}
                            defaultValue={this.state.username}
                          />
                          <label htmlFor="username">Username</label>
                          {empty && !username && <div className="input-error">Provide a username</div>}
                        </div>

                        {/* Email */}
                        <div className="form-group">
                          <input
                            type="email"
                            name="email"
                            id="email"
                            className={empty && !email ? 'form-control form-control-error' : 'form-control'}
                            autoComplete="off"
                            onChange={this.handleChange}
                            defaultValue={this.state.email}
                          />
                          <label htmlFor="email">E-mail</label>
                          {empty && !email && <div className="input-error">Provide a valid e-mail address</div>}
                        </div>

                        {/* Password */}
                        <div className="form-group">
                          <input
                            type="password"
                            name="password"
                            id="password"
                            className={empty && !password ? 'form-control form-control-error' : 'form-control'}
                            autoComplete="off"
                            onChange={this.handleChange}
                            defaultValue={this.state.password}
                          />
                          <label htmlFor="password">Password</label>
                          {empty && !password && <div className="input-error">Provide a password for your account</div>}
                        </div>

                        {/* Password confirmation */}
                        <div className="form-group">
                          <input
                            type="password"
                            name="password_confirmation"
                            id="password_confirmation"
                            className={empty && !password_confirmation ? 'form-control form-control-error' : 'form-control'}
                            autoComplete="off"
                            onChange={this.handleChange}
                            defaultValue={this.state.password_confirmation}
                          />
                          <label htmlFor="password_confirmation">Password confirmation</label>
                          {empty && !password_confirmation && <div className="input-error">Please, provide the same password again</div>}
                        </div>
                      </div>
                    </div>

                    <SubmitButton
                      type="submit"
                      color="blue"
                      submitted={submitted}
                      text="Signup"
                      altText="Creating user..."
                    />
                  </form>
                </div>
              </div>
            : <div className="row">
                <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 offset-3">
                  <Link to="/signin" className="btn btn-blue btn-table-center">Go back to Signin</Link>
                </div>
              </div>
          }
        </div>
        
        {
          !this.state.confirmationSubmitted ?
            <GenericFooterComponent classes="footer footer-registering not-fixed"/>
          : <GenericFooterComponent classes="footer footer-registering"/>
        }
      </div>
    )
  }
}

function mapStateToProps(state) {
  const { signUp } = state.signupReducer;
  return signUp;
}

const ConnectedSignupContainer = connect(mapStateToProps)(SignupContainer);
export { ConnectedSignupContainer as SignupContainer }